<!--
 * @Author: czj
 * @Date: 2025-04-11 15:18:12
 * @Description: 
 * @FilePath: \sanshu-report-new\src\components\ContentCom\comps\NodeForm.vue
-->
<template>
  <div class="curtom_form">

    <!--  <pre>{{formValues}}</pre> -->

    <!-- <button @click="console.log(formValues)">输出表单</button> -->

    <el-form ref="nodeFormRef" :label-position="'top'" :model="formValues">
      <div v-for="(group_item, i) in groupedData" :key="i">
        <h3 v-if="visibleCategory(group_item)">{{ group_item.category }}</h3>
        <div class="grid_container">
          <template v-for="(item, index) in group_item.items" :key="item.key">
            <div class="grid_item" v-if="visibleFields[item.key] && item.is_show">
              <el-form-item :key="item.key" :prop="item.key" :rules="getDynamicRules(item.key)">
                <template #label>
                  <div class="label_text_box">{{ item.title || item.key || item }}</div>
                  <el-popover placement="top-start" title="说明" width="200" trigger="hover" :content="item.description">
                    <template #reference>
                      <el-icon style="vertical-align: middle;">
                        <InfoFilled />
                      </el-icon>
                    </template>
                  </el-popover>
                </template>
                <template
                  v-if="filtered_object[item.key] && filtered_object[item.key] && filtered_object[item.key].assembly_type === 'input'">
                  <el-input v-model="formValues[item.key]" @input="(value)=>handleChange(item.key,value)" />
                </template>
                <template v-else-if="filtered_object[item.key] && filtered_object[item.key].assembly_type === 'select'">
                  <el-select style="width: 100%;" v-model="formValues[item.key]"
                    @change="(value)=>handleChange(item.key,value)">
                    <el-option v-for="(e,i) in filtered_object[item.key].select_data" :key="e.value" :label="e.label"
                      :value="e.value" />
                  </el-select>
                </template>
                <template
                  v-else-if="filtered_object[item.key] && filtered_object[item.key].assembly_type === 'checkbox'">
                  <el-checkbox-group v-model="formValues[item.key]" @change="(value)=>handleChange(item.key,value)">
                    <el-checkbox v-for="(e,i) in filtered_object[item.key].select_data" :key="e.value"
                      :label="e.value">{{e.label}}</el-checkbox>
                  </el-checkbox-group>
                </template>
                <template v-else-if="filtered_object[item.key] && filtered_object[item.key].assembly_type === 'radio'">
                  <el-radio-group v-model="formValues[item.key]" @change="(value)=>handleChange(item.key,value)">
                    <el-radio v-for="(e,i) in filtered_object[item.key].select_data" :key="e.value" :label="e.value">
                      {{e.label}}</el-radio>
                  </el-radio-group>
                </template>
                <template v-else-if="filtered_object[item.key] && filtered_object[item.key].assembly_type === 'switch'">
                  <el-switch v-model="formValues[item.key]" @change="(value)=>handleChange(item.key,value)" />
                </template>
                <template v-else-if="filtered_object[item.key] && filtered_object[item.key].assembly_type === 'number'">
                  <el-input-number style="width: 100%;" v-model="formValues[item.key]"
                    @change="(value)=>handleChange(item.key,value)" />
                </template>
                <template v-else-if="filtered_object[item.key] && filtered_object[item.key].assembly_type === 'color'">
                  <el-color-picker v-model="formValues[item.key]" @change="(value)=>handleChange(item.key,value)" />
                </template>
                <template
                  v-else-if="filtered_object[item.key] && filtered_object[item.key].assembly_type === 'textarea'">
                  <el-input style="width: 100%;" type="textarea" v-model="formValues[item.key]"
                    @input="(value)=>handleChange(item.key,value)" />
                </template>
                <template v-else-if="filtered_object[item.key] && filtered_object[item.key].assembly_type === 'date'">
                  <el-date-picker style="width: 100%;" v-model="formValues[item.key]" type="date"
                    @change="(value)=>handleChange(item.key,value)" />
                </template>
                <template v-else-if="filtered_object[item.key] && filtered_object[item.key].assembly_type === 'time'">
                  <el-time-select style="width: 100%;" v-model="formValues[item.key]"
                    @change="(value)=>handleChange(item.key,value)" />
                </template>
                <template
                  v-else-if="filtered_object[item.key] && filtered_object[item.key].assembly_type === 'datetime'">
                  <el-date-picker style="width: 100%;" v-model="formValues[item.key]" type="datetime"
                    @change="(value)=>handleChange(item.key,value)" />
                </template>
                <template v-else-if="filtered_object[item.key] && filtered_object[item.key].assembly_type === 'upload'">
                  <div class="file_path_box">
                    <div class="file_path" :title="formValues[item.key]">{{filePathHandle(formValues[item.key])}}</div>
                    <div class="file_path_btn">
                      <img class="sIcon" title="选择文件" src="/img/add.png" @click="openDialog(item.key)" />
                      <img class="sIcon" title="预览" src="/img/pre_view.png" @click="getFileData(item)" />
                    </div>
                  </div>
                </template>
                <template
                  v-else-if="filtered_object[item.key] && filtered_object[item.key].assembly_type === 'colorsgrouppicker'">
                  <ColorSelect v-model="formValues[item.key]"></ColorSelect>
                </template>
                <template v-else>
                  <el-input v-model="formValues[item.key]" @input="(value)=>handleChange(item.key,value)" />
                </template>
              </el-form-item>
            </div>
          </template>
          <div class="grid_item"></div>
          <div class="grid_item"></div>
        </div>
      </div>
    </el-form>
    <div v-if="groupedData.length === 0" style="padding:0 0 30px;">
      <el-divider>暂无数据</el-divider>
    </div>


    <el-dialog title="提示" v-model="dialogVisible" width="800px" :before-close="handleClose" append-to-body>
      <div>
        <SelectFile :currentKey="current_key" @saveinput="saveinput"></SelectFile>
      </div>
    </el-dialog>
    <el-dialog title="预览" v-model="is_dialog" width="600">
      <div v-if="file_data && is_dialog">
        <TableCom res="tableComs" :file_data="file_data" @updataFun="updataFun"></TableCom>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="is_dialog = false">取 消</el-button>
          <el-button type="primary" @click="updataFile">确 定</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script setup>
  import { ref, defineProps, watch, onBeforeMount, onMounted, onBeforeUpdate, onUpdated, onBeforeUnmount, onUnmounted, defineEmits } from 'vue';
  import PubSub from 'pubsub-js';
  import { ElMessage } from 'element-plus';
  import { validateArray, restoreFormKeys } from '@/utils/tool.js';
  import { useStore } from '@/Store/index.js';
  import { post_request, get_file_data, write_file_data } from '@/api/index.js';

  import SelectFile from '@/components/SelectFile/index.vue';
  import TableCom from '@/components/TableCom/index.vue';
  import ColorSelect from "@/components/FormComs/ColorSelect.vue";


  const store = useStore();
  const emit = defineEmits([])
  const props = defineProps({
    //['filtered_data', 'raw_item', 'associate_config']
    filtered_data: {
      type: Array,
      default: () => [
        {
          "key": "meta_workflow.ANOVO",
          "docker": "",
          "appname": "",
          "title": "ANOVO",
          "default": "/cephfs_data/genostack_v3/genostack_cromwell/cromwell-executions/untargetedMeta/d80e0ec7-598b-4531-aa0f-a3e6bbed37fb/call-mixPCA/execution/output/sample.xlsx",
          "type": "input",
          "description": "",
          "category": "parameter",
          "data_type": "String",
          "assembly_type": "upload",
          "options": [],
          "rule": null,
          "file_types": "",
          "is_quick_parameter": false,
          "is_required": true,
          "value": [],
          "params_type": null,
          "associate_config": null,
          "dependency": null,
          "select_data": []
        },
        {
          "key": "meta_workflow.Analyst",
          "docker": "",
          "appname": "",
          "title": "Analyst",
          "default": "yes",
          "type": "input",
          "description": "",
          "category": "parameter",
          "data_type": "String",
          "options": [],
          "rule": null,
          "file_types": "",
          "is_quick_parameter": false,
          "is_required": true,
          "value": [],
          "params_type": null,
          "associate_config": null,
          "dependency": null,
          "select_data": []
        },
        {
          "key": "meta_workflow.Identify_analyresult",
          "docker": "",
          "appname": "",
          "title": "Identify_analyresult",
          "default": "/cephfs_data/genostack_v3_dev/genostack_cromwell/cromwell-executions/meta_workflow/00a39a10-82e2-4a24-a491-41e466294399/call-Identify_analy/execution/output",
          "type": "input",
          "description": "",
          "category": "parameter",
          "data_type": "String",
          "options": [],
          "rule": null,
          "file_types": "",
          "is_quick_parameter": false,
          "is_required": true,
          "value": [],
          "params_type": null,
          "associate_config": null,
          "dependency": null,
          "select_data": []
        },
        {
          "key": "meta_workflow.QC_peak_QCP_res",
          "docker": "",
          "appname": "",
          "title": "QC_peak_QCP_res",
          "default": "/cephfs_data/genostack_v3_dev/genostack_cromwell/cromwell-executions/meta_workflow/00a39a10-82e2-4a24-a491-41e466294399/call-QC_peak/execution/QC_peak",
          "type": "input",
          "description": "",
          "category": "parameter",
          "data_type": "String",
          "options": [],
          "rule": null,
          "file_types": "",
          "is_quick_parameter": false,
          "is_required": true,
          "value": [],
          "params_type": null,
          "associate_config": null,
          "dependency": null,
          "select_data": []
        },
        {
          "key": "meta_workflow.configfile",
          "docker": "",
          "appname": "",
          "title": "configfile",
          "default": "/cephfs_data/genostack_v3_dev/genostack_php/project_data/4562/20240800843/data/options.xlsx",
          "type": "input",
          "description": "",
          "category": "parameter",
          "data_type": "String",
          "options": [],
          "rule": null,
          "file_types": "",
          "is_quick_parameter": false,
          "is_required": true,
          "value": [],
          "params_type": null,
          "associate_config": null,
          "dependency": null,
          "select_data": []
        },
        {
          "key": "meta_workflow.dbpath",
          "docker": "",
          "appname": "",
          "title": "dbpath",
          "default": "/cephfs_data/genostack_v3_dev/genostack_php/public_file_data/Dynamic_pipline/untargetedMeta/runtimedb2",
          "type": "input",
          "description": "",
          "category": "parameter",
          "data_type": "String",
          "options": [],
          "rule": null,
          "file_types": "",
          "is_quick_parameter": false,
          "is_required": true,
          "value": [],
          "params_type": null,
          "associate_config": null,
          "dependency": null,
          "select_data": []
        },
        {
          "key": "meta_workflow.predeal_pre_result",
          "docker": "",
          "appname": "",
          "title": "predeal_pre_result",
          "default": "/cephfs_data/genostack_v3_dev/genostack_cromwell/cromwell-executions/meta_workflow/00a39a10-82e2-4a24-a491-41e466294399/call-predeal/execution/predeal",
          "type": "input",
          "description": "",
          "category": "parameter",
          "data_type": "String",
          "options": [],
          "rule": null,
          "file_types": "",
          "is_quick_parameter": false,
          "is_required": true,
          "value": [],
          "params_type": null,
          "associate_config": null,
          "dependency": null,
          "select_data": []
        },
        {
          "key": "meta_workflow.raw",
          "docker": "",
          "appname": "",
          "title": "raw",
          "default": "yes",
          "type": "input",
          "description": "",
          "category": "parameter",
          "data_type": "String",
          "options": [],
          "rule": null,
          "file_types": "",
          "is_quick_parameter": false,
          "is_required": true,
          "value": [],
          "params_type": null,
          "associate_config": null,
          "dependency": null,
          "select_data": []
        },
        {
          "key": "meta_workflow.score",
          "docker": "",
          "appname": "",
          "title": "score",
          "default": "35",
          "type": "input",
          "description": "",
          "category": "parameter",
          "data_type": "Int",
          "options": [],
          "rule": null,
          "file_types": "",
          "is_quick_parameter": false,
          "is_required": true,
          "value": [],
          "params_type": null,
          "associate_config": null,
          "dependency": null,
          "select_data": []
        },
        {
          "key": "meta_workflow.score2",
          "docker": "",
          "appname": "",
          "title": "score2",
          "default": "60",
          "type": "input",
          "description": "",
          "category": "parameter",
          "data_type": "Int",
          "options": [],
          "rule": null,
          "file_types": "",
          "is_quick_parameter": false,
          "is_required": true,
          "value": [],
          "params_type": null,
          "associate_config": null,
          "dependency": null,
          "select_data": []
        },
        {
          "key": "meta_workflow.tax",
          "docker": "",
          "appname": "",
          "title": "tax",
          "default": "Animals",
          "type": "input",
          "description": "",
          "category": "parameter",
          "data_type": "String",
          "options": [],
          "rule": null,
          "file_types": "",
          "is_quick_parameter": false,
          "is_required": true,
          "value": [],
          "params_type": null,
          "associate_config": null,
          "dependency": null,
          "select_data": []
        },
        {
          "key": "meta_workflow.type",
          "docker": "",
          "appname": "",
          "title": "type",
          "default": "LC",
          "type": "input",
          "description": "",
          "category": "parameter",
          "data_type": "String",
          "options": [],
          "rule": null,
          "file_types": "",
          "is_quick_parameter": false,
          "is_required": true,
          "value": [],
          "params_type": null,
          "associate_config": null,
          "dependency": null,
          "select_data": []
        },
        {
          "key": "meta_workflow.workDir",
          "docker": "",
          "appname": "",
          "title": "workDir",
          "default": "/cephfs_data/genostack_v3_dev/genostack_php/project_data/4562/20240800843",
          "type": "input",
          "description": "",
          "category": "parameter",
          "data_type": "String",
          "options": [],
          "rule": null,
          "file_types": "",
          "is_quick_parameter": false,
          "is_required": true,
          "value": [],
          "params_type": null,
          "associate_config": null,
          "dependency": null,
          "select_data": []
        }
      ]
    },
    raw_item: {
      type: Object,
    },
    associate_config: {
      type: Object,
    }
  });


  const formValues = ref({});// 存储表单数据
  const visibleFields = ref({}); // 控制字段显示
  const rules = ref({}); // 存储表单验证规则
  const dialogVisible = ref(false);
  const current_key = ref(null);
  const is_dialog = ref(false);
  const file_data = ref(null);
  const table_data = ref(null);
  const form_list = ref([]);
  const groupedData = ref([]);//参数类别分组数据
  const filtered_object = ref({});//过滤后的对象
  const node_data_token = ref(null);// 节点数据token

  const nodeFormRef = ref(null);// 表单实例


  //数组转对象
  function arrayToObject(arr) {
    if (!Array.isArray(arr)) return {};
    let obj = {};
    arr.forEach(item => {
      obj[item.key || item.raw_key] = item;
    });
    return obj;
  };

  const associateCallback = function (config) { // 关联配置回调函数
    const { unit_key, select_val, } = config;
    if (!config.associate_config) return false;
    const associate_config = JSON.parse(config.associate_config);
    const params = {
      callback_function: associate_config.callback_function,
      callback_name: associate_config.callback_name,
      [associate_config.callback_name]: select_val,
    };
    post_request(associate_config.callback_route, params).then((result) => {
      const callback_specify_fields = associate_config.callback_specify_fields;
      if (callback_specify_fields) for (const key in callback_specify_fields) {
        if (callback_specify_fields[key].indexOf('.') != -1) { //判断是否包含分隔符
          let data = getValueByPath(result, callback_specify_fields[key]);
          setNestedPropertyValue(filtered_object.value, key, data);
        } else {
          setNestedPropertyValue(filtered_object.value, key, result[callback_specify_fields[key]]);
        }
      };
    }).catch((err) => {
      console.error(err);
    });
  };


  const getValueByPath = function (obj, path) { // 根据路径获取值
    const keys = path.split('/');
    let result = obj;
    for (const key of keys) {
      if (result && result.hasOwnProperty(key)) {
        result = result[key];
      } else {
        return undefined; // 如果属性不存在，返回 undefined
      }
    };
    return result;
  };

  const setNestedPropertyValue = function (obj, path, value) { // 设置嵌套属性的值
    const modifiedPath = path.replace(/\./g, '-');
    if (obj[modifiedPath]) {
      obj[modifiedPath]['select_data'] = value;
    } else {
      obj[path]['select_data'] = value;
    }
  };

  const handleParamsCategory = function (params_list) { // 参数类别分组
    const groupMap = {
      '其他': []  // 默认“其他”分组
    };
    let groupedData = [];
    params_list.forEach(item => {
      const category = item.params_type || '其他';
      if (!groupMap[category]) groupMap[category] = [];
      const new_e = {
        key: item.key || item.raw_key,
        raw_key: item.raw_key,
        title: item.title,
        description: item.description,
        is_show: item.is_show,
      };
      groupMap[category].push(new_e);
    });
    const groupedDataWithoutOther = Object.keys(groupMap).filter(category => category !== '其他').map(category => ({ category, items: groupMap[category] }));

    const otherGroup = {
      category: '其他',
      items: groupMap['其他']
    };
    groupedData = [...groupedDataWithoutOther, otherGroup];
    return groupedData;
  };

  const visibleCategory = function (groupItem) { // 控制字段显示
    const flag = groupedData.value.length > 1 || groupItem.category !== '其他';
    return flag;
  };

  const filePathHandle = function (filePath) {
    //隐藏全路径，只显示最后一级
    //例如： cephfs_data/genostack_v3/genostack_cromwell/test/testdata/indata/options.xlsx
    const arr = filePath.split('/');
    return arr[arr.length - 1];
  };

  const formatFormData = function (formData) { //格式化表单数据
    const result = formData.map(item => {
      const modifiedKey = item.key.replace(/\./g, '-');
      if (item.dependency) {// 处理 dependency 内部的 key
        if (item.dependency.conditions) {// 处理多条件依赖（如 conditions）
          item.dependency.conditions = item.dependency.conditions.map(condition => {
            return { ...condition, key: condition.key.replace(/\./g, '-') };
          });
        } else { // 处理单一依赖
          item.dependency.key = item.dependency.key.replace(/\./g, '-');
        }
      };
      return { ...item, key: modifiedKey, raw_key: item.key };
    });
    return result;
  };

  function trimQuotes(str) { // 去除双引号
    if (typeof str === 'string' && str.startsWith('"') && str.endsWith('"')) {
      return str.slice(1, -1);
    }
    return str;
  };

  const initFunc = function () {
    if (props.filtered_data && props.filtered_data.length > 0) {
      form_list.value.forEach(item => {
        formValues.value[item.key] = item.default !== undefined ? trimQuotes(item.default) : null;
        visibleFields.value[item.key] = !item.dependency;// 初始化字段的可见性
        if (item.is_required) { // 初始化验证规则
          rules.value[item.key] = [{ required: true, message: `请输入${item.title}`, trigger: 'blur' }];
        };
        if (item.dependency) {// 处理依赖关系
          setupDependency(item);
        };
      });
    }
  };

  const setupDependency = function (item) { // 处理依赖关系
    const dep = item.dependency;
    if (dep.conditions) {//多条件
      dep.conditions.forEach((cond) => {
        watch(() => formValues.value[cond.key], (newValue) => {
          checkConditions(item, dep);
        });
      });
    } else {//单一条件
      watch(() => formValues.value[dep.key], (newValue) => {
        checkDependency(item, dep);
      });
    }
  };

  const checkConditions = function (item, dep) { //处理多条件依赖
    const conditionsMet = dep.conditions.every((cond) => {
      return evaluateCondition(formValues.value[cond.key], cond.operator, cond.value);
    });
    visibleFields.value[item.key] = conditionsMet;
  };

  const checkDependency = function (item, dep) { //处理单一条件依赖
    const conditionMet = evaluateCondition(formValues.value[dep.key], dep.operator, dep.value);
    visibleFields.value[item.key] = conditionMet;
  };

  const handleChange = function (ite, val) { // 表单值改变时触发

  };

  const evaluateCondition = function (fieldValue, operator, value) { //判断依赖条件是否满足
    switch (operator) {
      case '==':
        return fieldValue == value;
      case '!=':
        return fieldValue != value;
      case '>':
        return fieldValue > value;
      case '>=':
        return fieldValue >= value;
      case '<':
        return fieldValue < value;
      case '<=':
        return fieldValue <= value;
      case 'includes':
        return fieldValue.includes(value);
      case 'excludes':
        return !fieldValue.includes(value);
      case "contains":
        return Array.isArray(fieldValue) && fieldValue.includes(value);
      default:
        return false;
    }
  };

  const validateForm = function () { // 表单验证
    const firstForm = nodeFormRef.value;
    return new Promise((resolve, reject) => {
      firstForm.validate((valid) => {
        if (valid) {
          resolve(true); // 校验通过
        } else {
          reject(false); // 校验不通过
        }
      });
    });
  };

  const getDynamicRules = function (key) { // 动态验证规则
    const item = form_list.value.find(item => item.key === key);
    if (item && visibleFields.value[item.key] && item.is_required) {
      return [{ required: true, message: `请输入${item.title || item.raw_key || item.key}`, trigger: 'blur' }];
    };
    return [];
  };

  const openDialog = function (key) { // 打开弹窗
    current_key.value = key;
    dialogVisible.value = true;
  };

  const handleClose = function () { // 关闭弹窗
    dialogVisible.value = false;
  };

  const saveinput = function (val) { // 保存输入值
    if (val) formValues.value[current_key.value] = val;
    if (validateArray(form_list.value)) {//流程参数
      const process_form = restoreFormKeys(formValues.value);
      store.setProcessForm(process_form);//保存流程参数
    }
  };

  const getFileData = function (item) { // 获取文件数据
    current_key.value = item.key;
    const file_path = formValues.value[item.key];
    const params = {
      "callback_name": "file_path",
      "file_path": file_path,
      "callback_function": {
        "file_format": "table"
      }
    };
    get_file_data(params).then((result) => {
      file_data.value = {
        "file_path": file_path,
        "data": result.data
      };
      is_dialog.value = true;
    }).catch((err) => {
      console.error(err);
    });
  };

  const updataFun = function (datas) { // 更新表单数据
    table_data.value = datas;
  };

  const updataFile = function () { // 更新文件数据
    const file_path = formValues.value[current_key.value];
    const params = {
      "callback_name": "file_path",
      "file_path": file_path,
      "callback_function": {
        "type": "table"
      },
      "data": table_data.value
    };
    write_file_data(params).then((result) => {
      if (result.code == 200) {
        ElMessage.success('表格修改成功');
        is_dialog.value = false
      };
    }).catch((err) => {
      console.error(err);
    });
  };


  // 使用 watch 监听 props 的字段变化
  watch(() => props.associate_config, (newData, oldData) => {
    associateCallback(newData);
  });
  //组件即将挂载
  onBeforeMount(() => {
    if (props.filtered_data && props.filtered_data.length > 0) {
      form_list.value = formatFormData(props.filtered_data);
      filtered_object.value = arrayToObject(form_list.value);
      groupedData.value = handleParamsCategory(form_list.value);
      initFunc();
    };

  });
  //组件已经挂载
  onMounted(() => {
    if (validateArray(form_list.value)) { //流程参数
      const process_form = restoreFormKeys(formValues.value);
      store.setProcessForm(process_form);//保存流程参数
    };
    if (props.raw_item) {
      node_data_token.value = PubSub.subscribe(props.raw_item.title, function (msg, data) { // 监听节点数据变化
        if (!data.inputs_json) {
          console.error(`${props.raw_item.title},当前节点表单没有输入数据`, data);
          return;
        };
        let keys = Object.keys(data.inputs_json);
        keys.forEach(key => {
          if (formValues.value.hasOwnProperty(key)) {
            formValues.value[key] = data.inputs_json[key];
          }
        });
      });
    }
  });
  //组件即将更新
  onBeforeUpdate(() => {
  });
  //组件已经更新
  onUpdated(() => {
  });
  //组件即将卸载
  onBeforeUnmount(() => {
    if (node_data_token.value) PubSub.unsubscribe(node_data_token.value);
  });
  //组件已经卸载
  onUnmounted(() => {
  });
  //暴露
  defineExpose({
    formValues,
    validateForm
  });

</script>
<style scoped>
  .label_text_box {
    display: inline-block;
    vertical-align: middle;
    max-width: calc(100% - 50px);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-right: 5px;
  }


  .file_path_box {
    width: 100%;
    height: 32px;
    /* border: 1px solid #EBEEF5; */
    border: 1px solid var(--el-border-color);
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: 4px;
  }

  .file_path {
    flex: 1;
    line-height: normal;
    /* 超出显示省略号 */
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding: 0 10px;
  }

  .file_path_btn {
    padding: 0 20px;
    line-height: normal;
    border-left: 1px solid #EBEEF5;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .file_path_btn .sIcon:last-child {
    margin-left: 10px;
  }


  .select_icon,
  .sIcon {
    width: 19px;
    cursor: pointer;
    vertical-align: middle;
  }
</style>
<style>
  /* 自定义表单样式 */

  .curtom_form .el-form--label-top .el-form-item__label {
    line-height: normal;
    display: block;
    padding: 0 !important;
  }



  /* 网格布局 */
  .grid_container {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: start;
    gap: 15px;
  }

  .grid_container .grid_item {
    width: calc(100% / 3 - 20px);
    /* margin-bottom: 20px; */
  }

  .grid_item .el-form-item {
    margin-bottom: 0 !important;
  }

  .grid_item .el-form-item__content .el-input-group {
    vertical-align: middle !important;
  }
</style>